module.exports = __webpack_public_path__ + "img/scream.ce76e0ab.png";